import React, { useState, useEffect } from 'react'
import { Form, Pagination, Button, Card, Row, Col } from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import toast from 'react-hot-toast'
import Cookies from 'js-cookie'
import axios from 'axios'
import { FaSyncAlt } from 'react-icons/fa'
import { useParams } from 'react-router-dom'
import { Typeahead } from 'react-bootstrap-typeahead'
import { Table, Tbody, Td, Th, Thead, Tr } from 'react-super-responsive-table'
import { useAuth } from './AuthContext'

const DataTable = () => {
const {token} = useAuth()
const institute_id = Cookies.get('institute_id')
  const [marginLeft, setMarginLeft] = useState(
    window.innerWidth > 768 ? '300px' : '0px',
  )

  useEffect(() => {
    const handleResize = () => {
      setMarginLeft(window.innerWidth > 768 ? '270px' : '0px')
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])
  const { student_id, course_id, class_id } = useParams()
  console.log(
    'student_id: ',
    student_id,
    'course_id: ',
    course_id,
    'class_id: ',
    class_id,
  )

  const [selectedClass, setSelectedClass] = useState('')
  // const [selectedTeachers, setSelectedTeachers] = useState('')
  const [openTable, setOpenTable] = useState(false)

  const [classes, setClasses] = useState([])
  // const [teachers, setTeachers] = useState([])
  const [students, setStudents] = useState([])
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split('T')[0],
  )

  const [data, setData] = useState([])
  const [search, setSearch] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(5)
  // const [selectedDate, setSelectedDate] = useState('')
  const [resetKey, setResetKey] = useState(0)
  const [courses, setCourses] = useState([])
  const [selectedCourseId, setSelectedCourseId] = useState(null)
  const [selectedStudentId, setSelectedStudentId] = useState(null)
  const [filteredStudents, setFilteredStudents] = useState([])
  const [selectedStudent, setSelectedStudent] = useState(null)
  useEffect(() => {
    ApiEndpoints.getAllClasses().then((res) => {
      console.log('Classes:', res.data.data)
      setClasses(res.data.data)
    })
  }, [])

  useEffect(() => {
    ApiEndpoints.getAllCourses()
      .then((res) => {
        console.log('Courses', res.data.data)
        setCourses(res.data.data)
      })
      .catch(console.error)
  }, [])

  useEffect(() => {
    if (selectedCourseId) {
      ApiEndpoints.getAllClassesByCourseId(selectedCourseId)
        .then((res) => {
          const { data } = res
          if (data.status === false || !data.data?.length) {
            setClasses([])
          } else {
            setClasses(data.data)
            // setSelectedClass(classId)
          }
        })
        .catch(() => {
          setClasses([])
        })
    }
  }, [selectedCourseId])
  useEffect(() => {
    if (course_id) {
      handleCourseChange({ target: { value: course_id } })
    }
  }, [course_id])

  useEffect(() => {
    const institueId = Cookies.get('institute_id')
    const userCookie = Cookies.get('user')

    let token = null
    if (userCookie) {
      try {
        const user = JSON.parse(userCookie)
        token = user.token
        console.log('TOKEN:', token)
      } catch (error) {
        console.error('Failed to parse user cookie', error)
      }
    }
    const fetchFilteredData = async () => {
      try {
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          institute_id: institute_id || institueId,
        }

        const response = await axios.get(
          BASE_URL+'/student/all',
          { headers },
        )
        const students = response.data.data

        const student =
          students.find((st) => Number(st.id) === Number(student_id)) || 'N/A'
        console.log('Select Student data:', student)

        const studentParId = students.find(
          (st) => Number(st.id) === Number(student_id),
        )
        setFilteredStudents(studentParId)
        // setStudents(students)
        // setSelectedStudent(student)
        // setStudents(response.data.data)
      } catch (error) {
        console.error(error.response?.data?.message || 'Something wents wrong.')
      }
    }
    fetchFilteredData()
  }, [])

  useEffect(() => {
    if (course_id || class_id || student_id) {
      const selectedValues = {
        course_id: course_id,
        class_id: class_id,
        student_id: student_id,
      }
      setSelectedData(selectedValues)
      setOpenTable(true)
      fetchFilteredData(selectedValues)
    }
  }, [class_id, course_id, student_id])
  const handleStatusChange = (studentId, newStatus) => {
    setData((prevData) =>
      prevData.map((student) =>
        student.id === studentId ? { ...student, status: newStatus } : student,
      ),
    )
    console.log(`🟢 Student ID: ${studentId}, New Status: ${newStatus}`)
  }

  const handleRemarksChange = (studentId, newRemarks) => {
    setData((prevStudents) =>
      prevStudents.map((student) =>
        student.id === studentId
          ? { ...student, remarks: newRemarks }
          : student,
      ),
    )
    console.log(`📝 Student ID: ${studentId}, New Remarks: ${newRemarks}`)
  }

  // const filteredData = students.filter((item) =>
  //   Object.values(item).some(
  //     (value) =>
  //       value &&
  //       typeof value === 'string' &&
  //       value.toLowerCase().includes(search.toLowerCase()),
  //   ),
  // )

  // const searchedData = filteredData.filter(
  //   (student) =>
  //     student.studentName &&
  //     student.studentName.toLowerCase().includes(search.toLowerCase()),
  // )

  // const totalPages = Math.ceil(searchedData.length / itemsPerPage)
  // const currentItems = searchedData.slice(
  //   (currentPage - 1) * itemsPerPage,
  //   currentPage * itemsPerPage,
  // )

  // useEffect(() => {
  //   let filteredStu = students
  //   console.log('🔵 Filtered Students:', filteredData)

  //   if (selectedClass) {
  //     const instituteId = Cookies.get('institute_id')

  //     const headers = {
  //       institute_id: Number(instituteId),
  //     }

  //     axios
  //       .get(
  //         BASE_URL+`/get/student/by-class?class_id=${selectedClass}`,
  //         { headers },
  //       )
  //       // .then((res) => {
  //       //   const classStudents = res.data.data || []
  //       //   console.log('Fetched Students by class:', classStudents)

  //       //   // const classStudentIds = new Set(classStudents.map((stu) => stu.id))
  //       //   // const filteredData = filteredStu.filter((student) =>
  //       //   //   classStudentIds.has(student.id),
  //       //   // )
  //       //   // console.log(
  //       //   //   '✅ Filtered Data to Display classStudentIds:',
  //       //   //   classStudentIds,
  //       //   // )

  //       //   // console.log('✅ Filtered Data to Display filteredData:', filteredData)

  //       //   setData(classStudents) // for table
  //       // })
  //       .then((res) => {
  //         console.log('Students after class select:', res.data.data)
  //         setFilteredStudents(res.data.data)
  //       })
  //       .catch((error) => {
  //         // This is where 404 or other errors come
  //         if (
  //           error.response?.data?.message === 'No classes found for this course'
  //         ) {
  //           console.error('No classes found for this course.')
  //         } else {
  //           console.error('Error fetching classes:', error)
  //           console.error('Something went wrong while fetching classes.')
  //         }
  //         setFilteredStudents([])
  //         setClasses([])
  //       })
  //   }
  // }, [students, selectedClass])

  const handleSaveAttendance = async () => {
    try {
      const allowedStatuses = ['present', 'absent', 'leave'] // Ensure these match backend values

      const attendanceData = data.map((student) => ({
        student_id: student.id,
        status: allowedStatuses.includes(student.status) ? student.status : '', // Default to 'present' if invalid

        remarks: student.remarks || '',
      }))

      const payload = {
        // teacher_id: selectedTeachers,
        class_id: selectedClass,
        attendance: attendanceData,
      }
      console.log('📌 Sending Payload:', JSON.stringify(payload, null, 2))

      const response = await ApiEndpoints.addAttendance(payload)
      console.log('Response send:', response)
      toast.success(response.data.message)
    } catch (error) {
      console.error('Error Response:', error.response?.data?.message)
      toast.error(error.response?.data?.message)
    }
  }

  const [selectedData, setSelectedData] = useState({})

  const handleSelect = (selectedValues) => {
    setSelectedData(selectedValues)

    if (selectedValues.class) {
      const classId = selectedValues.class
      setSelectedClass(classId)
      // setClasses(classId)
      // console.log('classId', classId)
      setOpenTable(true)
      // Filter students belonging to the selected class
      const filtered = students.filter(
        (student) =>
          student.class_id != null &&
          classId != null &&
          student.class_id.toString() === classId.toString(),
      )
      console.log('filtered', filtered)
      setFilteredStudents(filtered)
      setData(filtered)
    }
  }

  const fetchFilteredData = ({ course, class: classId, student }) => {
    let updatedData = students
    console.log('COURSE:', course)
    console.log('class:', classId)
    console.log('student:', student)

    if (course) {
      updatedData = updatedData.filter(
        (item) => item.course_id?.toString() === course.toString(),
      )
      console.log('courseId', course)
    }

    if (classId) {
      updatedData = updatedData.filter(
        (item) => item.class_id?.toString() === classId.toString(),
      )
      console.log('classId', classId)
    }

    // if (student) {
    //   updatedData = updatedData.filter(
    //     (item) => item?.name?.toLowerCase().includes(student.toLowerCase()),
    //     console.log('student', student),
    //   )
    // }
    if (student) {
      console.log('STUDENT AFTER SELECT:', student)
      const studentName = students.find((s) => s.id === Number(student))?.name
      console.log('STUDENT NAME:', studentName?.name)
      if (studentName) {
        const updatedData = students.filter((item) =>
          item.name?.toLowerCase().includes(studentName.toLowerCase()),
        )
        setData(updatedData)
      }
    }

    // Update the state with the filtered data
    setFilteredStudents(updatedData)
  }

  useEffect(() => {
    fetchFilteredData(selectedData)
  }, [selectedData])

  const handleRefresh = () => {
    setSelectedData({})
    setData([])
    setOpenTable(false)
    setResetKey((prev) => prev + 1)
  }

  useEffect(() => {
    if (course_id) {
      handleCourseChange({ target: { value: course_id } })
    }
  }, [course_id])

  const handleCourseChange = async (e) => {
    const courseId = e.target.value
    setSelectedCourseId(courseId)
    setClasses([])
    setFilteredStudents([])
    setSelectedData([])
    // setSelectedStudentId(null)
    // setSelectedClassId(null)
    // setSelectedStudent(null)

    console.log('courseId ', courseId, 'and', 'course_id', course_id)
    setOpenTable(true)
    if (courseId) {
      const res = await ApiEndpoints.getAllClassesByCourseId(courseId)
      setClasses(res.data.data)
    }
    if (courseId) {
      ApiEndpoints.getAllClassesByCourseId(courseId)
        .then((res) => {
          const { data } = res
          if (data.status === false || !data.data?.length) {
            toast.error('No classes found for this course.')
            setClasses([])
            setOpenTable(false)
          } else {
            setClasses(data.data)
          }
        })
        .catch((error) => {
          // This is where 404 or other errors come
          if (
            error.response?.data?.message === 'No classes found for this course'
          ) {
            toast.error('No classes found for this course.')
          } else {
            console.error('Error fetching classes:', error)
            toast.error('Something went wrong while fetching classes.')
          }
          setClasses([])
        })
    }
  }
  const handleClassChange = (e) => {
    // setHasModifiedFields(true)
    const classId = e.target.value
    console.log(' Targeted classId', classId)
    setSelectedClass(classId)

    // const filtered = students.filter(
    //   (student) => student.class_id === Number(classId),
    // )
    // console.log('filtered', filtered)
    // setFilteredStudents(filtered)
    // setSelectedStudentId(null)
    // setSelectedStudent(null)
    // setSelectedData([])
    // setSelectedFees([])
    setOpenTable(true)

    if (classId) {
      const institueId = Cookies.get('institute_id')
      const headers = {
        institute_id: institute_id || institueId,
        Authorization: `Bearer ${token}`
      }
      console.log('HEADERS:', headers)
      axios
        .get(
          BASE_URL+`/get/student/by-class?class_id=${classId}`,
          { headers },
        )
        .then((res) => {
          console.log('Students after class select:', res.data.data)
          setData(res.data.data)
          setStudents(res.data.data)
        })
        .catch((error) => {
          // This is where 404 or other errors come
          if (
            error.response?.data?.message === 'No classes found for this course'
          ) {
            console.error('No classes found for this course.')
          } else {
            console.error('Error fetching classes:', error)
            console.error('Something went wrong while fetching classes.')
          }
          setClasses([])
        })
    }
  }
  const handleStudentChange = async (e) => {
    const studentId = e.target.value
    setSelectedStudent(studentId)
    // setOpenTable(true)
    const student = students.find((s) => s.id === Number(studentId))

    setData(student ? [student] : students)
    // setFilteredStudents(student)

    // setSelectedFees([])
    setOpenTable(true)
  }
  return (
    <div style={{ marginLeft }}>
      <div
        className="container-fluid p-0"
        style={{
          marginTop: window.innerWidth < 768 ? '55px' : '-12px',
        }}
      >
        <div className="bg-secondary p-3 rounded d-flex flex-wrap justify-content-between align-items-center text-white">
          <h2 className="m-0">Take Attendance</h2>
        </div>
      </div>

      {/* <Row className="g-3 mt-3 flex-nowrap">
        <Col>
          <SelectableField
            onSelect={handleSelect}
            showCourse={true}
            showClass={true}
            showStudent={true}
            abc={'abc'}
            setData={setData}
            resetTrigger={resetKey}
          />
        </Col>
        <Col xs="auto" className="d-flex align-items-center mt-4">
          <Button
            variant="outline-primary"
            onClick={handleRefresh}
            title="Refresh"
          >
            <FaSyncAlt /> Refresh
          </Button>
        </Col>
      </Row> */}

      <Row className="g-2 align-items-end d-flex mt-3 flex-wrap">
        <Col md={3}>
          <Form.Group className="text-start fw-bold mb-0">
            <Form.Label>Select Course</Form.Label>
            <Typeahead
              id="course-select"
              labelKey="name"
              onChange={(selected) => {
                const course = selected[0]
                if (course) {
                  handleCourseChange({ target: { value: course.id } })
                } else {
                  handleCourseChange({ target: { value: '' } })
                }
              }}
              options={courses}
              placeholder="Select Course"
              selected={courses.filter(
                (cs) => cs.id === Number(selectedCourseId || course_id || ''),
              )}
            />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="text-start fw-bold mb-0">
            <Form.Label>Select Class</Form.Label>

            <Typeahead
              id="class-select"
              labelKey="class_name"
              onChange={(selected) => {
                const cls = selected[0]
                if (cls) {
                  handleClassChange({ target: { value: cls.id } })
                } else {
                  handleClassChange({ target: { value: '' } })
                }
              }}
              options={classes}
              placeholder="Select Class"
              selected={classes.filter(
                (cs) => cs.id === Number(selectedClass || class_id || ''),
              )}
            />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="text-start fw-bold">
            <Form.Label>Select Student</Form.Label>

            <Typeahead
              id="student-select"
              labelKey={(option) =>
                `${option.name} - ${option.admission_number}`
              }
              onChange={(selected) => {
                const student = selected[0]
                if (student) {
                  handleStudentChange({ target: { value: student.id } })
                } else {
                  handleStudentChange({ target: { value: '' } })
                }
              }}
              options={students}
              placeholder="Select Student"
              selected={
                Array.isArray(students)
                  ? students.filter(
                      (s) => s.id === Number(selectedStudent || ''),
                    )
                  : []
              }
            />
          </Form.Group>
        </Col>
        <Col className="d-flex justify-content-md-end justify-content-start">
          <Button
            variant="outline-primary"
            onClick={handleRefresh}
            title="Refresh"
            className="mt-3"
          >
            <FaSyncAlt />
          </Button>
        </Col>
      </Row>

      {/* Search & Items Per Page Selector */}
      {openTable && (
        <div className="d-flex justify-content-end align-items-center gap-3 mb-3 mt-2">
          <p className="text-black m-0">
            {/* Total Students: {filteredData.length} */}
          </p>
          <Form.Select
            className="w-auto"
            value={itemsPerPage}
            onChange={(e) => {
              setItemsPerPage(parseInt(e.target.value))
              setCurrentPage(1)
            }}
          >
            <option value="10">10 per page</option>
            <option value="20">20 per page</option>
            <option value="30">30 per page</option>
          </Form.Select>
        </div>
      )}

      {/* {openTable && ( */}
      {openTable && (
        <div className="d-flex flex-wrap justify-content-between align-items-center my-3">
          <div className="d-flex flex-column" style={{ marginTop: '-1.5rem' }}>
            <p className="text-start fw-bold mb-1 ">Today</p>
            <Form.Control
              type="date"
              style={{ maxWidth: '180px' }}
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)} // Allow user to pick a date
            />
          </div>
          {data.length > 0 && (
            <div className="d-flex gap-2 ">
              <Button
                variant="primary"
                // onClick={() => {
                //   setFilteredStudents((prevStudents) => {
                //     const updatedStudents = prevStudents.map((student) => ({
                //       ...student,
                //       status: 'present',
                //     }))
                //     console.log('🟢 Marked All Present:', updatedStudents)
                //     return updatedStudents
                //   })
                // }}
                onClick={() => {
                  const updated = data.map((student) => ({
                    ...student,
                    status: 'present',
                  }))
                  setData(updated)
                  console.log('🟢 Marked All Present:', updated)
                }}
              >
                Mark All Present
              </Button>

              <Button
                variant="secondary"
                onClick={() => {
                  // setFilteredStudents((prevStudents) => {
                  //   const updatedStudents = prevStudents.map((student) => ({
                  //     ...student,
                  //     status: 'absent',
                  //   }))
                  //   console.log('🔴 Marked All Absent:', updatedStudents)
                  //   return updatedStudents
                  // })
                  const updated = data.map((student) => ({
                    ...student,
                    status: 'absent',
                  }))
                  setData(updated)
                  console.log('🟢 Marked All Absent:', updated)
                }}
              >
                Mark All Absent
              </Button>
            </div>
          )}
        </div>
      )}

      {openTable && data?.length > 0 ? (
        <>
          <Table className="table table-striped table-bordered table-hover rounded overflow-hidden shadow-sm mb-0">
            <Thead className="bg-dark text-white">
              <Tr className="bg-secondary rounded">
                {/* <Th>Attendance Id</Th> */}
                <Th>Admission Number</Th>
                <Th>Student Name</Th>
                {/* <Th>Class Name</Th> */}
                {/* <Th>Section</Th> */}
                <Th>Status</Th>
                <Th>Remarks</Th>
              </Tr>
            </Thead>
            <Tbody className="text-start">
              {data.map((item, index) => {
                // const classId = item.class_id || item.class?.id
                // console.log('ccccccccc', classId)
                // c
                // console.log('🟡 Student item:', item)

                // const classId = item.class_id
                // const matchedClass = classes.find((cls) => {
                //   console.log('🔍 Checking class:', cls.id, 'vs', classId)
                //   return cls.id.toString() === classId?.toString() // safely compare as strings
                // })

                // console.log(
                //   '✅ Matched class for student',
                //   classId,
                //   matchedClass,
                // )

                return (
                  <Tr key={index}>
                    {/* <Td>{index + 1}</Td> */}
                    <Td>{item.admission_number}</Td>
                    <Td>{item.name}</Td>
                    {/* <Td>
                      {classes.find((cls) => cls.id === item.class_id)
                        ?.class_name || '-'}
                    </Td> */}

                    {/* <Td>{item.section}</Td> */}
                    {/* <Td>
              <Form.Check
                type="switch"
                checked={item.status}
                onChange={() => handleStatusChange(item.attendanceId)}
                label={item.status ? 'Present' : 'Absent'}
              />
            </Td> */}
                    <Td>
                      <Form.Select
                        value={item.status || ''}
                        onChange={(e) =>
                          handleStatusChange(item.id, e.target.value)
                        }
                      >
                        <option value="">Select</option>
                        <option value="present">Present</option>
                        <option value="absent">Absent</option>
                        <option value="leave">Leave</option>
                        {/* <option value="late">Late</option> */}
                      </Form.Select>
                    </Td>
                    <Td>
                      <Form.Control
                        type="text"
                        placeholder="Enter remarks"
                        value={item.remarks || ''}
                        onChange={(e) =>
                          handleRemarksChange(item.id, e.target.value)
                        }
                        disabled={
                          item.status !== 'present' && item.status !== 'leave'
                        }
                      />
                    </Td>
                  </Tr>
                )
              })}
            </Tbody>
          </Table>

          <div className="d-flex flex-wrap justify-content-between align-items-center mb-5 mt-4 gap-2">
            <div>
              <Button
                style={{ display: 'block', marginLeft: 0, marginTop: '-1rem' }}
                variant="success"
                onClick={handleSaveAttendance}
              >
                Save Attendance
              </Button>
            </div>
            <Pagination>
              <Pagination.Prev
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              />
              {/* {[...Array(totalPages)].map((_, i) => (
                <Pagination.Item
                  key={i}
                  active={i + 1 === currentPage}
                  onClick={() => setCurrentPage(i + 1)}
                >
                  {i + 1}
                </Pagination.Item>
              ))} */}
              <Pagination.Next
              // onClick={() =>
              //   setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              // }
              // disabled={currentPage === totalPages}
              />
            </Pagination>
          </div>
        </>
      ) : (
        <p className="text-center mt-3">No students found.</p>
      )}
    </div>
  )
}

export default DataTable
